import { render, staticRenderFns } from "./btnSectorEdit.vue?vue&type=template&id=6833e29f"
import script from "./btnSectorEdit.vue?vue&type=script&lang=js"
export * from "./btnSectorEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports